// client/src/api/auth/register.ts
import apiClient from "../client";
import { AxiosError } from "axios";

export interface RegisterRequest {
  firstName: string;
  lastName: string;
  email: string;
  password: string;
  referralCode?: string;
}

export interface RegisterResponse {
  success: boolean;
  message: string;
  needsVerification?: boolean;
  token?: string;
  redirectPath?: string;
  data?: {
    user: {
      _id: string;
      username: string;
      email: string;
      role: string;
      isVerified: boolean;
      twoFactorEnabled: boolean;
      profile?: {
        firstName?: string;
        lastName?: string;
        phone?: string;
        avatar?: string;
      };
      referralCode?: string;
      createdAt: string;
      updatedAt: string;
    };
    token: string;
    refreshToken: string;
    sessionId: string;
  };
}

export const register = async (userData: RegisterRequest): Promise<RegisterResponse> => {
  try {
    // console.log("API register function received:", userData);
    // console.log("Making POST request to /auth/register");
    
    const response = await apiClient.post<RegisterResponse>('/auth/register', userData);
    
    // console.log("API response:", response.data);
    
    // Identity ADR: never store tokens in localStorage (XSS → permanent account
    // takeover). The session is carried by the HttpOnly cookie the backend sets;
    // we keep only a non-sensitive user hint for UI bootstrap.
    if (response.data.success && response.data.data) {
      localStorage.setItem('sessionId', response.data.data.sessionId);
      localStorage.setItem('user', JSON.stringify(response.data.data.user));
    }
    
    return response.data;
  } catch (error: unknown) {
    console.error("API error:", error);
    if (error instanceof AxiosError) {
      console.error("Error response:", error.response?.data);
      const errorData = error.response?.data || { success: false, message: 'Registration failed' };
      const errorMessage = errorData.error || errorData.message || 'Registration failed';
      throw new Error(errorMessage);
    }
    throw new Error(error instanceof Error ? error.message : 'Registration failed');
  }
};
